import { useState } from "react";
import Dialog from "components/ui/Dialog/Dialog";
import { useDialog } from "context/DialogContext";
import Button from "components/ui/Button/Button";
import Loader from "components/ui/Loader/Loader";
import useData from "hooks/useData";
import Alert from "components/ui/Alert/Alert";
import PropTypes from "prop-types";
import { useAccount } from "context/AccountContext";
import { Redirect } from "react-router-dom";
import ProfileDeletedExplain from "pages/Profile/ProfileDeletedExplain";

const ProfileDelete = ({ id }) => {
  const { user, setUser, setProfile } = useAccount();
  const { deleteData } = useData();
  const { hideDialog } = useDialog();
  const [ working, setWorking ] = useState(false);
  const [ error, setError ] = useState();
  const { showDialog } = useDialog();

  const onConfirm = async () => {
    setWorking(true);
    const result = await deleteData(`rest/user/${ id }`, true);
    if (result.status !== 200) {
      setError(`Uw profiel kon niet worden verwijderd (${ result.status })`);
    }
    else {
      setUser(null);
      setProfile(null);
      showDialog(<ProfileDeletedExplain/>);
    }

    setWorking(false);
  };

  if (!user) {
    return <Redirect to={ `/` }/>;
  }

  return (
    <Dialog title={ `Weet u zeker dat u uw profiel wilt verwijderen?` }>
      { error && <Alert message={ error }/> }
      { working ? <Loader/> :
        <>
          <div className={ `dialog__row` }>
            <h3>Al uw privéberichten, prikbordberichten en andere gegevens zullen worden verwijderd!</h3>
            <div className={ 'dialog__row' }>
              Zolang u lid bent van ANBO-PCOB kunt u na het verwijderen altijd een nieuw profiel aanmaken door opnieuw in te loggen met het e-mailadres dat bij ANBO-PCOB bekend is en uw gekozen wachtwoord.
            </div>
          </div>
          <div className="dialog__buttons">
            <Button variant={ `ghost` } onClick={ () => hideDialog() }>Annuleren</Button>
            <Button variant={ `danger` } onClick={ onConfirm }>Ja, verwijder mijn profiel</Button>
          </div>
        </>
      }
    </Dialog>
  )
}

ProfileDelete.propTypes = {
  id: PropTypes.number.isRequired,
}

export default ProfileDelete;
